import { toast } from "react-toastify";
import { ComponentsList } from "../ComponentsMap";
import { ComponentService } from "../Services/Axios/Api";
import { ToastContainer } from "react-bootstrap";

export const DEFAULT_NAV_SETTINGS = {
    showLanguageSwitcher: true,
    showSearch: true,
};

class Nav {
    data = {};
    constructor() {
        this.data = {
            id: '1',
            ComponentName: 'NavBasic',
            type: 'NavCenter',
            logo: '',
            menuItems: [
                { id: 1, order: 1, type: "link", text: 'Home', link: '/' },
                { id: 2, order: 2, type: "link", text: 'Donations', link: '/donations' },
                { id: 3, order: 3, type: "link", text: 'Pricing', link: '#pricing' },
                {
                    id: 4,
                    type: "button",
                    button: {
                        text: 'Login',
                        link: '/login',
                        type: 'link',
                        className: 'NavBtn',
                        style: {},
                        icon: null,
                    },
                },
            ],
            style: {
                NavBasic: { backgroundColor: "#ffff", position: "sticky", top: "0", "z-index": "1000" },
                NavBasicLinkItem: { "color": "black" },
                NavBasicLinkItemHover: { "color": "grey" },
                NavBasicToggle: { "color": "black" },
            },
            animation:{
                animationType:"",
                animationDuration:"",
                animationDelay:"",
            },
            settings: { ...DEFAULT_NAV_SETTINGS },
        };
    }
    // Id   
    getId() { return this.data.id; }
    setId(id) { this.data.id = id; }
    // Name
    getComponentName() { return this.data.ComponentName; }
    setComponentName(ComponentName) { this.data.ComponentName = ComponentName; }
    // Logo
    getLogo() { return this.data.logo; }
    setLogo(logo) { this.data.logo = logo; }
    getType() { return this.data.type; }
    setType(type) { this.data.type = type; }
    // menu items
    getMenuItems() { return [...this.data.menuItems]; }
    setMenuItems(menuItems) { this.data.menuItems = [...menuItems]; }
    removeMenuItem(id) {
        this.data.menuItems = this.data.menuItems.filter(item => item.id !== id);
    }
    addMenuItem(item) {
        this.data.menuItems = [...this.data.menuItems, item];
    }
    updateMenuItem(id, updatedData, type) {
        this.data.menuItems = this.data.menuItems.map(item => {
            if (item.id === id) {
                if (type === 'link') {
                    return { ...item, text: updatedData.text, link: updatedData.link, order: updatedData.order };
                } else if (type === 'button' && item.type === 'button') {
                    return {
                        ...item,
                        button: {
                            ...item.button,
                            text: updatedData.text || item.button.text,
                            link: updatedData.link || item.button.link,
                            type: updatedData.buttonType || item.button.type,
                            className: updatedData.className || item.button.className,
                            style: updatedData.style || item.button.style,
                            icon: Object.prototype.hasOwnProperty.call(updatedData, 'icon') ? updatedData.icon : item.button.icon
                        }
                    };
                }
            }
            return item;
        });
    }

    // Convenience getters/setters for a button item's icon
    getButtonIconById(id) {
        const item = this.data.menuItems.find(mi => mi.id === id && mi.type === 'button');
        return item?.button?.icon ?? null;
    }
    setButtonIconById(id, iconNameOrNull) {
        this.data.menuItems = this.data.menuItems.map(item => {
            if (item.id === id && item.type === 'button') {
                return {
                    ...item,
                    button: {
                        ...item.button,
                        icon: iconNameOrNull
                    }
                };
            }
            return item;
        });
    }

    // style
    getStyle() { return this.data.style; }
    setStyle(style) { this.data.style = style; }

    getBackgroundColor() {
         return this.data.style.NavBasic.backgroundColor; 
        }
    setBackgroundColor(color) { this.data.style.NavBasic.backgroundColor = color; }

    getTextColor() { return this.data.style.NavBasicLinkItem.color; }
    setTextColor(color) { this.data.style.NavBasicLinkItem.color = color; }

    getPosition() { return this.data.style.NavBasic.position; }
    setPosition(position) { this.data.style.NavBasic.position = position; }

    // animation
    getAnimation() { return this.data.animation || { animationType: "fade-down", animationDuration: "1000", animationDelay: "100" }; }
    setAnimation(animation) { this.data.animation = { ...this.getAnimation(), ...animation }; }
    getAnimationType() { return this.getAnimation().animationType; }
    setAnimationType(type) { this.setAnimation({ animationType: type }); }
    getAnimationDuration() { return this.getAnimation().animationDuration; }
    setAnimationDuration(duration) { this.setAnimation({ animationDuration: duration }); }
    getAnimationDelay() { return this.getAnimation().animationDelay; }
    setAnimationDelay(delay) { this.setAnimation({ animationDelay: delay }); }

    // settings
    getSettings() {
        return { ...DEFAULT_NAV_SETTINGS, ...(this.data.settings || {}) };
    }
    setSettings(settings) {
        this.data.settings = { ...DEFAULT_NAV_SETTINGS, ...settings };
    }
    getShowLanguageSwitcher() {
        return this.getSettings().showLanguageSwitcher;
    }
    setShowLanguageSwitcher(show) {
        this.setSettings({ ...this.getSettings(), showLanguageSwitcher: show });
    }
    getShowSearch() {
        return this.getSettings().showSearch;
    }
    setShowSearch(show) {
        this.setSettings({ ...this.getSettings(), showSearch: show });
    }

    // data
    getData() { return this.data; }
    setData(data) { this.data = data; }


    // methods
    async load(Language) {
        try {
            const response = await ComponentService.getStaticComponent(this.data.ComponentName, Language, true);
            const data = JSON.parse(response?.data);
            this.setData(data);
            this.setId(response?.id);
            this.setLogo(data.logo);
            this.setMenuItems(data.menuItems);
            this.setStyle(data.style);
            if (data.animation) { this.setAnimation(data.animation); }
            this.setSettings(data.settings || DEFAULT_NAV_SETTINGS);
            return(JSON.parse(response?.data));


        } catch (error) {
            throw new Error(error.response.data);

        }


    }
    async save() {
        try {
            const response = await ComponentService.SaveData(this.getId(), this.getData());
            console.log(response);
            
            return response;

        } catch (error) {
            throw new Error(error.response.data);

        }
    }
}

export const createNavInstance = () => new Nav();
